<template>
  <div class="invest-markets">
    <div class="container">
      <h1>
        <strong>Getting To Unicorn Status ie BILLION Dollar Valuation:</strong>
      </h1>
      <div class="row">
        <div class="invest-markets-col">
          <div class="invest-flags w-100">
            <div v-for="flag in flags" :key="flag.code" class="invest-flag">
              <img :src="getFlagImageUrl(flag.code)" />
              {{ flag.name }}
            </div>
          </div>
        </div>
        <div class="invest-markets-col">
            WE ARE ALREADY:
            <ul>
                <li>
                    <strong>OOYYO is ranked #1 in 15 countries</strong> such as France, Spain, Russia, Turkey
                </li>
                <li>
                    OOYYO ranks at least top 5 in <strong>Google results for "used cars"</strong> in 25+ countries
                </li>
                <li>
                    <strong>Currently presents in 27 countries</strong> with 10 million active users over last twelve months.
                </li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    flags() {
      return [
        {
          code: "147",
          name: "Austria",
        },
        {
          code: "115",
          name: "Bulgaria",
        },
        {
          code: "106",
          name: "Denmark",
        },
        {
          code: "15",
          name: "France",
        },
        {
          code: "123",
          name: "Hungaria",
        },
        {
          code: "7",
          name: "Italy",
        },
        {
          code: "118",
          name: "Latvia",
        },
        {
          code: "14",
          name: "Netherlands",
        },
        {
          code: "102",
          name: "Norway",
        },
        {
          code: "97",
          name: "Poland",
        },
        {
          code: "107",
          name: "Portugal",
        },
        {
          code: "128",
          name: "Romania",
        },
        {
          code: "100",
          name: "Russia",
        },
        {
          code: "17",
          name: "Spain",
        },
        {
          code: "104",
          name: "Ukraine",
        },
      ];
    },
  },
  methods: {
    getFlagImageUrl(code) {
      return require(`@/images/flags/flag_${code}.png`);
    }
  }
};
</script>
